module.exports = __webpack_public_path__ + "img/80.06cbf6bd.png";